import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { api, ApiError, queryKeys, setAuthToken } from "../api/client";
import { clearToken, resolveInitialToken } from "./token";

type Props = { children: (label: string | null, isAdmin: boolean) => JSX.Element };

export function TokenGate({ children }: Props) {
  const [token, setToken] = useState<string | null>(() => {
    const t = resolveInitialToken();
    setAuthToken(t);
    return t;
  });

  const auth = useQuery({
    queryKey: queryKeys.authCheck,
    queryFn: api.authCheck,
    enabled: token !== null,
    retry: false,
  });

  useEffect(() => {
    if (auth.error instanceof ApiError && auth.error.status === 401) {
      clearToken();
      setAuthToken(null);
      setToken(null);
    }
  }, [auth.error]);

  if (token === null || (auth.isError && auth.error instanceof ApiError && auth.error.status === 401)) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
        <h1 className="text-2xl font-semibold">Hääkuvatunkki</h1>
        <p className="max-w-md text-sm text-ink/70">
          Tämä kutsulinkki ei toimi. Skannaa pöytäkorttisi QR-koodi tai ota yhteyttä hääpariin.
        </p>
      </div>
    );
  }

  if (auth.isLoading || !auth.data) {
    return <div className="flex h-full items-center justify-center text-sm">Ladataan…</div>;
  }

  return children(auth.data.label, auth.data.is_admin);
}
